<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7"> Historie </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="orderHeadersByRole"
        :items="revision.items"
        :options.sync="revision.options"
        :server-items-length="revision.serverItemsLength"
        :loading="revision.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.revision.modifiedAt="{ item }">
          <DateTime :single-line="false" :datetime="item.revision.modifiedAt" />
        </template>
        <template v-slot:item.revisionType="{ item }">
          <RevisionType :revision="item.revisionType" />
        </template>
        <template v-slot:item.entity.type="{ item }">
          {{ item.entity.type.text }}
        </template>
        <template v-slot:item.entity.statusCode="{ item }">
          <OrderStatus :status="item.entity.statusCode" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import OrderStatus from '@/components/order/OrderStatus'
import RevisionType from '@/components/revision/RevisionType'

export default {
  name: 'OrderRevisions',
  components: {
    RevisionType,
    OrderStatus,
    DateTime,
  },
  mixins: [setFilters],
  props: {
    id: {
      id: Number,
      required: true,
    },
    status: {
      id: String,
      required: true,
    },
  },
  data() {
    return {
      revision: {
        headers: [
          {
            text: 'Datum',
            value: 'revision.modifiedAt',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Akce',
            value: 'revisionType',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Uživatel',
            value: 'revision.modifiedBy',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Typ',
            value: 'entity.type',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Stav',
            value: 'entity.statusCode',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      revisionFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    orderHeadersByRole() {
      return this.revision.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    status: {
      handler() {
        this.loadRevisions()
      },
    },
    'revision.options': {
      handler() {
        this.loadRevisions()
      },
    },
    '$route.query': {
      handler() {
        this.loadRevisions()
      },
    },
  },
  methods: {
    ...mapActions({
      searchRevisions: 'order/searchOrderAuditRevisions',
    }),
    loadRevisions() {
      this.revision.loading = true
      const searchParams = {
        options: this.revision.options,
      }
      this.searchRevisions({ id: this.id, params: searchParams })
        .then((response) => {
          this.revisionFooter.totalElements = response.data.totalElements
          this.revision.items = response.data.items
          this.revision.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.revision.loading = false
        })
    },
    setFiltersAction(filters) {
      this.revision.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
